import React, { useState } from "react";
import "../CSS/DetailPasienTK.css";
import { FaCalendarAlt } from "react-icons/fa";

function DetailPasienTK() {
  const [activeTab, setActiveTab] = useState("dataPasien");
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    id: "0001",
    nama: "Nezuko",
    telepon: "085231256566",
    tempatLahir: "Magetan",
    tanggalLahir: "23-01-1985",
    umur: "30",
    alamat:
      "Desa Buluharjo, Rt.07/Rw.09, Kecamatan Plaosan, Kabupaten Magetan, Jawa Timur",
    nakes: "Dr. Muichiro",
    faskes: "RSUD Magetan",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    alert("Perubahan data pasien telah disimpan!");
    setIsEditing(false);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  return (
    <div className="detailpasien-page">
      <div className="main-contentdetailpasien">
        <div className="detailpasien-container">
          <div className="profile-section">
            <div className="profile-avatar">PS</div>
            <div className="profile-info">
              <h3>{formData.nama}</h3>
              <div className="status-info">
                <span className="status-active">● Status: Aktif</span>
                <span className="risk-low">● Risiko: Rendah</span>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="tabs">
            <button
              className={activeTab === "dataPasien" ? "tab active" : "tab"}
              onClick={() => setActiveTab("dataPasien")}
            >
              Data Pasien
            </button>
            <button
              className={activeTab === "riwayatTerapi" ? "tab active" : "tab"}
              onClick={() => setActiveTab("riwayatTerapi")}
            >
              Riwayat Terapi
            </button>
            <button
              className={
                activeTab === "riwayatScreening" ? "tab active" : "tab"
              }
              onClick={() => setActiveTab("riwayatScreening")}
            >
              Riwayat Screening
            </button>
          </div>

          {/* Tab Content */}
          {activeTab === "dataPasien" && (
            <div className="data-pasien-form">
              <div className="form-left">
                <label>ID Pasien</label>
                <input
                  type="text"
                  name="id"
                  value={formData.id}
                  readOnly
                />

                <label>Nama Lengkap</label>
                <input
                  type="text"
                  name="nama"
                  value={formData.nama}
                  onChange={handleChange}
                />

                <label>Nomor Telepon</label>
                <input
                  type="text"
                  name="telepon"
                  value={formData.telepon}
                  onChange={handleChange}
                  
                />

                <label>Tempat Lahir</label>
                <input
                  type="text"
                  name="tempatLahir"
                  value={formData.tempatLahir}
                  onChange={handleChange}
                  
                />

                <label>Tanggal Lahir</label>
                <div className="input-with-icon">
                  <input
                    type="text"
                    name="tanggalLahir"
                    value={formData.tanggalLahir}
                    onChange={handleChange}
                    
                  />
                  <FaCalendarAlt className="calendar-icon" />
                </div>

                <label>Umur</label>
                <input
                  type="text"
                  name="umur"
                  value={formData.umur}
                  onChange={handleChange}
                  
                />
              </div>

              <div className="form-right">
                <label>Alamat Lengkap</label>
                <textarea
                  className="poppins-textarea"
                  rows="4"
                  name="alamat"
                  value={formData.alamat}
                  onChange={handleChange}
                  
                ></textarea>

                <label>Tenaga Kesehatan Penanggung Jawab</label>
                <select
                  name="nakes"
                  value={formData.nakes}
                  onChange={handleChange}
                 
                >
                  <option>Dr. Muichiro</option>
                  <option>Dr. Tanjiro</option>
                  <option>Dr. Shinobu</option>
                </select>

                <label>Alamat Fasilitas Kesehatan</label>
                <select
                  name="faskes"
                  value={formData.faskes}
                  onChange={handleChange}
                  
                >
                  <option>RSUD Magetan</option>
                  <option>RS Bhayangkara</option>
                  <option>Klinik Sakura</option>
                </select>

                {/* Tombol Aksi */}
                <div className="button-group">
                <button className="save-btn" onClick={handleSaveClick}>
                  Simpan Perubahan
                </button>
                <button className="cancel-btn" onClick={handleCancelClick}>
                  Batal
                </button>
              </div>

              </div>
            </div>
          )}

          {activeTab === "riwayatTerapi" && (
            <div className="tab-content">
              <p>Menampilkan riwayat terapi pasien</p>
            </div>
          )}

          {activeTab === "riwayatScreening" && (
            <div className="tab-content">
              <p>Menampilkan riwayat screening pasien</p>
            </div>
          )}
        </div>

        <footer className="footerdetail">
          © 2025 TibiSmart. All rights reserved.
        </footer>
      </div>
    </div>
  );
}

export default DetailPasienTK;
